import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import ExpandImg from '../assets/expand.jpg';
import Hit from '../assets/hit_horiz_2.jpg';
import Flexibility from '../assets/flex_horiz.jpg';
import Energy from '../assets/dependencyOfEnergy.png';


// /#/webservers
function Webservers() {

  const history = useHistory();


  return (
    <div class="inner-section">
    	<div class="container">

				<h3 class="header-title">Structure Manipulation Tools</h3>
				<Card>
					<Img width="20vw" src={ExpandImg}/>
								<Description>
									Tools to manipulate two biomolecules (proteins, DNAs, RNAs, etc.), including
									separation, rotation, spin, shift, expand and detach.
								</Description>
					<Button onClick={()=> history.push('./manipulationTool') }>Go</Button>
				</Card>


        <h3 class="header-title" >Hybrid Ions Treatment</h3>
				<Card>
					<Img width="20vw" src={Hit}/>
						<Description>
							The tool to calculate the bound ions for biomolecules from MD simulation trajectories.
					 </Description>
					<Button onClick={()=> history.push('./hitV2') } >Go</Button>
				</Card>

				<h3 class="header-title" >PH Dependency of Energy</h3>
				<Card>
					<Img width="20vw" src={Energy}/>
						<Description>
							This tool is to vizualize the folding/binding energy of biomolecules.
					 </Description>
					<Button onClick={()=> history.push('./phDependencyOfEnergy') } >Go</Button>
				</Card>

        <h3 class="header-title">Flexibility Tool</h3>
				<Card>
					<Img width="20vw" src={Flexibility}/>
								<Description>
									The flexibility calculation tool is to evaluate the flexibility
                  of a single residue or a whole protein.
								</Description>
					<Button onClick={()=> history.push('./flexibility') }>Go</Button>
				</Card>
		 </div>

    </div>




  );
}

const Img = styled.img`
	width: ${ props => props.width ? props.width : "180px"};

`;

const Card = styled.div`
		background-color: #F5F7F9;
		box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
		transition: 0.3s;
		border-radius: 5px; /* 5px rounded corners */
		display:flex;
		flex-direction:row;
		margin-top:25px;
		margin-bottom:35px;
		display: flex;
		align-items:center;

`;

const Description = styled.p`
	  font-size:17px;
		width: 80%;
		margin-left:20px;
		margin-right:20px;
		font-family:'Fira Sans';
`;

const Button = styled.button`
		border: none;
		width: 200px;
		height:50px;
		margin-right:10px;
		color: #fff;
		background-color: #7eb35b;
		font-size: 1.2em;
		transform-style: preserve-3d;
		outline: none;
		cursor: pointer;
		border-radius: 0.27em;
		text-align: center;
		font-family:'Fira Sans';
		border-color: #52c41a;
    box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
`;


export default Webservers;



// WEBPACK FOOTER //
// ./src/pages/webservers.js